"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Caret = function Caret(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#000' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size;
  var iconSize = size === 'original' ? 'width="9.14" height="6.4"' : 'width="100%"';
  var title = 'Caret Icon';
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" ").concat(iconSize, " xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9.14 6.4\">\n      <title>").concat(title, "</title>\n      <polygon points=\"7.65 0 4.47 3.52 1.48 0.01 0 1.35 4.57 6.4 9.14 1.34 7.65 0\" style=\"fill: ").concat(color, "\" />\n    </svg>\n  ");
};

var _default = Caret;
exports["default"] = _default;